"use client";

import { Stack, Typography, Box } from "@mui/material";
import theme from "@/theme/theme";
import QrCard from "./qrCard";

const SOURCES = ["Repositories", "OS", "Middleware", "Networks", "Libraries", "Certificates", "Hardware"];

const STAGES = [
    {
        title: "LLM agent network",
        description: "Reads your estate in context, in any language or format, entirely inside your perimeter.",
    },
    {
        title: "Crypto Bill of Materials",
        description: "A full inventory of where cryptography lives, with critical chains identified.",
    },
    {
        title: "Classified findings",
        description: "Every algorithm, key and certificate marked classical or quantum-safe.",
    },
    {
        title: "Migration roadmap",
        description: "A prioritised, supplier-aware plan you can act on and re-run anytime.",
    },
];

const Connector = () => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.brand.mgsLightBlue1.main,
            transform: { xs: "rotate(90deg)", lg: "none" },
            paddingY: { xs: 0.5, lg: 0 },
            flexShrink: 0,
            fontSize: "1.4rem",
            lineHeight: 1,
        }}
    >
        &rarr;
    </Box>
);

const QrFlow = () => {
    return (
        <Stack gap={3}>
            <Typography variant="h6" component="h6" fontWeight={400}>
                How a scan flows
            </Typography>

            {/* Input sources */}
            <Stack direction="row" flexWrap="wrap" gap={1} justifyContent={{ xs: "flex-start", lg: "center" }}>
                {SOURCES.map((source) => (
                    <Box
                        key={source}
                        sx={{
                            border: `1px solid ${theme.palette.brand.border1.main}`,
                            borderRadius: 999,
                            paddingX: 1.5,
                            paddingY: 0.5,
                            backgroundColor: "#15151559",
                        }}
                    >
                        <Typography component="span" fontSize="0.75rem !important" color={theme.palette.text.secondary}>
                            {source}
                        </Typography>
                    </Box>
                ))}
            </Stack>

            <Connector />

            {/* Pipeline stages */}
            <Stack direction={{ xs: "column", lg: "row" }} alignItems="stretch" justifyContent="center">
                {STAGES.map((stage, i) => (
                    <Stack
                        key={stage.title}
                        direction={{ xs: "column", lg: "row" }}
                        alignItems="stretch"
                        flex={1}
                    >
                        <QrCard sx={{ flex: 1 }}>
                            <Stack gap={1} height="100%">
                                <Typography component="span" className="chno" fontSize="0.7rem !important" color={theme.palette.brand.mgsLightBlue1.main} letterSpacing={1}>
                                    {String(i + 1).padStart(2, "0")}
                                </Typography>
                                <Typography variant="h6" component="h6" fontWeight={400} fontSize="0.95rem !important">
                                    {stage.title}
                                </Typography>
                                <Typography variant="body2" component="p" fontSize="0.8rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                    {stage.description}
                                </Typography>
                            </Stack>
                        </QrCard>
                        {i < STAGES.length - 1 && <Connector />}
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default QrFlow;
